// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/sort-comp */
import React, { PureComponent } from "react"
import { injectIntl, IntlShape } from "react-intl"
import { connect } from "react-redux"
import Alert from "@kiwicom/orbit-components/lib/Alert"

import { clearNotice as _clearNotice, Notice as NoticeType } from "../../services/notice"
import { Container } from "./styles"

type Props = {
  notice: NoticeType
  clearNotice: typeof _clearNotice
  intl: IntlShape
}

class Notice extends PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    const { notice } = this.props

    if (notice !== prevProps.notice) {
      if (this.noticeTimeout) {
        clearTimeout(this.noticeTimeout)
      }

      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      if (notice && notice.ttl !== null) {
        // @ts-expect-error: Flow to TS migration.
        this.noticeTimeout = setTimeout(this.handleClose, notice.ttl)
      }
    }
  }

  handleClose = () => {
    const { notice, clearNotice } = this.props

    if (!notice) {
      return
    }

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (notice.onClose) {
      notice.onClose()
    }

    if (this.noticeTimeout) {
      clearTimeout(this.noticeTimeout)
    }

    clearNotice()
  }

  // FIXME: sort methods in React components according to conventions

  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/member-ordering
  noticeTimeout: number

  render() {
    const { notice, intl } = this.props

    return (
      notice && (
        <Container>
          <Alert
            type={notice.type}
            icon={notice.icon}
            closable={notice.closable}
            onClose={this.handleClose}
            labelClose={intl.formatMessage({
              id: "orbit.button_close",
              defaultMessage: "Close",
            })}
            title={notice.title}
          >
            {notice.content}
          </Alert>
        </Container>
      )
    )
  }
}

export default connect(
  (state) => ({
    // @ts-expect-error: Flow to TS migration.
    notice: state.notice,
  }),
  {
    clearNotice: _clearNotice,
  },
)(injectIntl(Notice))
